// import { getwithdrawrequests } from "../../Api/AdminApiCall";

// getuserlist

import { createAsyncThunk, createSlice } from "@reduxjs/toolkit";
import { getwithdrawrequests, getcheckbalance, fetchwithdraRequest, fetchwithdraonboardinglink, fetchkycstatus as fetchkycstatusApi ,paymentdashboard,getpayoutrequests,fetchstripewebhooks,fetchNDASign,getAdminpayoutlist,fetchwithdraRetry} from "../../Api/AdminApiCall";
import { getUserWalletTransactionHistory } from "../../Api/AffiliateApiCall";


export const fetchgetwithdrawrequest = createAsyncThunk(
    "admin/fetchgetwithdrawrequest",
    async ({ page = 1, search = '', status = '' }, { rejectWithValue }) => {
        try {
            const res = await getwithdrawrequests(page, search, status);
            return res.data;
        } catch (error) {
            return rejectWithValue(
                error.response?.data || "Failed to load users"
            );
        }
    }
);

export const fetchpaymentdashboard = createAsyncThunk(
    "admin/fetchpaymentdashboard",
    async (_, { rejectWithValue }) => {
        try {
            const res = await paymentdashboard();
            return res.data;
        } catch (error) {
            return rejectWithValue(
                error.response?.data || "Failed to load users"
            );
        }
    }
);

export const fetchgetcheckbalance = createAsyncThunk(
    "admin/fetchgetcheckbalance",
    async (userid, { rejectWithValue }) => {
        try {
            const res = await getcheckbalance(userid);
            return res.data;
        } catch (error) {
            return rejectWithValue(
                error.response?.data || "Failed to load users"
            );
        }
    }
);

export const fetchAdminpayoutlist = createAsyncThunk(
    "admin/fetchAdminpayoutlist",
    async ({page, pageSize, status, search}, { rejectWithValue }) => {
        try {
            const res = await getAdminpayoutlist(page, pageSize, status, search);
            return res.data;
        }
        catch (error) {
            return rejectWithValue(
                error.response?.data || "Failed to load users"
            );
        }
    }
);

export const fetchwithdraRequests = createAsyncThunk(
    "admin/fetchwithdraRequests",
    async ({userid ,amount}, { rejectWithValue }) => {
      
        try {
            const res = await fetchwithdraRequest(userid,amount);
            return res.data;
        } catch (error) {
            return rejectWithValue(
                error.response?.data || "Failed to load users"
            );
        }
    }
);

export const fetchwithdraRetryApi = createAsyncThunk(
    "admin/fetchwithdraRetryApi",
    async ({userid,amount}, { rejectWithValue }) => {
        try {
            const res = await fetchwithdraRetry(userid,amount);
            return res.data;
        }
    catch (error) {
        return rejectWithValue(
            error.response?.data || "Failed to load users"
        );
    }
    }
);
export const fetchgetonboardinglink = createAsyncThunk(
    "admin/fetchgetonboardinglink",
    async ({userid,returnlink ,refreshlink}, { rejectWithValue }) => {
        try {
            const res = await fetchwithdraonboardinglink(userid,returnlink,refreshlink);
            return res.data;
        } catch (error) {
            return rejectWithValue(
                error.response?.data || "Failed to load users"
            );
        }
    }
);

export const fetchNDASignApi = createAsyncThunk(
    "admin/fetchNDASignApi",
    async (data, { rejectWithValue }) => {
        try {
            const res = await fetchNDASign(data);
            return res.data;
        } catch (error) {
            return rejectWithValue(
                error.response?.data || "Failed to load users"
            );
        }
    }
);

export const fetchkycstatus = createAsyncThunk(
    "admin/fetchkycstatus",
    async (userid, { rejectWithValue }) => {
        try {
            const res = await fetchkycstatusApi(userid);
            return res.data;
        } catch (error) {
            return rejectWithValue(
                error.response?.data || "Failed to load users"
            );
        }
    }
);

export const fetchgetpayoutrequests = createAsyncThunk(
    "admin/fetchgetpayoutrequests",
    async (_, { rejectWithValue }) => {
        try {
            const res = await getpayoutrequests();
            return res.data;
        } catch (error) {
            return rejectWithValue(
                error.response?.data || "Failed to load users"
            );
        }
    }
);

export const fetchstripewebhooksapi = createAsyncThunk(
    "admin/fetchstripewebhooksapi",
    async (payload, { rejectWithValue }) => {
        try {
            // Support both old format (data only) and new format ({ data, headers })
            const { data, headers = {} } = payload?.data !== undefined 
                ? payload 
                : { data: payload, headers: {} };
            
            const res = await fetchstripewebhooks(data, headers);
            return res.data;
        } catch (error) {
            return rejectWithValue(
                error.response?.data || "Failed to load users"
            );
        }
    }
);

export const fetchUserWalletTransactionHistory = createAsyncThunk(
    "admin/fetchUserWalletTransactionHistory",
    async (_, { rejectWithValue }) => {
        try {
            const res = await getUserWalletTransactionHistory();
            return res.data;
        }
        catch (error) {
            return rejectWithValue(
                error.response?.data || "Failed to load users"
            );
        }
    }
);
// fetchwithdraonboardinglink

// fetchwithdraRequest


// checkbalancedata,Adminwithdrarequest

const AdminwithdrarequestSlice = createSlice({
    name: "Adminwithdrarequest",
    initialState: {
        withdrawrequestlist: [],
        paymentdashboard:[],
        checkbalancedata: [],
        withdrawreuest:[],
        withdrawreuestRetry:[],
        OnboardUrl:[],
        kycstatus:[],
        payoutrequests:[],
        stripewebhooks:[],
        Adminpayoutlist:[],
        userWalletTransactionHistory:[],
        // propertydropdown:[],
        loading: false,
        error: null,
    },
    reducers: {
        clearWithdrawRequest: (state) => {
            state.withdrawreuest = [];
        },
    },
    extraReducers: (builder) => {
        builder
            .addCase(fetchgetwithdrawrequest.pending, (state) => {
                state.loading = true;
                state.error = null;
            })
            .addCase(fetchgetwithdrawrequest.fulfilled, (state, action) => {
                state.loading = false;
                state.withdrawrequestlist = action.payload;
            })
            .addCase(fetchgetwithdrawrequest.rejected, (state, action) => {
                state.loading = false;
                state.error = action.payload;
            })
            .addCase(fetchpaymentdashboard.pending, (state) => {
                state.loading = true;
                state.error = null;
            })
            .addCase(fetchpaymentdashboard.fulfilled, (state, action) => {
                state.loading = false;
                state.paymentdashboard = action.payload;
            })
            .addCase(fetchpaymentdashboard.rejected, (state, action) => {   
                state.loading = false;
                state.error = action.payload;
            })

            .addCase(fetchgetcheckbalance.pending, (state) => {
                state.loading = true;
                state.error = null;
            })
            .addCase(fetchgetcheckbalance.fulfilled, (state, action) => {
                state.loading = false;
                state.checkbalancedata = action.payload;
            })
            .addCase(fetchgetcheckbalance.rejected, (state, action) => {
                state.loading = false;
                state.error = action.payload;
            })

            .addCase(fetchwithdraRequests.pending, (state) => {
                state.loading = true;
                state.error = null;
            })
            .addCase(fetchwithdraRequests.fulfilled, (state, action) => {
                state.loading = false;
                state.withdrawreuest = action.payload;
            })
            .addCase(fetchwithdraRequests.rejected, (state, action) => {
                state.loading = false;
                state.error = action.payload;
            })

             .addCase(fetchgetonboardinglink.pending, (state) => {
                state.loading = true;
                state.error = null;
            })
            .addCase(fetchgetonboardinglink.fulfilled, (state, action) => {
                state.loading = false;
                state.OnboardUrl = action.payload;
            })
            .addCase(fetchgetonboardinglink.rejected, (state, action) => {
                state.loading = false;
                state.error = action.payload;
            })
            .addCase(fetchkycstatus.pending, (state) => {
                state.loading = true;
                state.error = null;
            })
            .addCase(fetchkycstatus.fulfilled, (state, action) => {
                state.loading = false;
                state.kycstatus = action.payload;
            })
            .addCase(fetchkycstatus.rejected, (state, action) => {
                state.loading = false;
                state.error = action.payload;
            })
            .addCase(fetchgetpayoutrequests.pending, (state) => {
                state.loading = true;
                state.error = null;
            })
            .addCase(fetchgetpayoutrequests.fulfilled, (state, action) => {
                state.loading = false;
                state.payoutrequests = action.payload;
            })
            .addCase(fetchgetpayoutrequests.rejected, (state, action) => {
                state.loading = false;
                state.error = action.payload;
            })
            .addCase(fetchstripewebhooksapi.pending, (state) => {
                state.loading = true;
                state.error = null;
            })
            .addCase(fetchstripewebhooksapi.fulfilled, (state, action) => {
                state.loading = false;
                state.stripewebhooks = action.payload;
            })
            .addCase(fetchstripewebhooksapi.rejected, (state, action) => {
                state.loading = false;
                state.error = action.payload;
            })
            // NDA
            .addCase(fetchNDASignApi.pending, (state) => {
                state.loading = true;
                state.error = null;
            })
            .addCase(fetchNDASignApi.fulfilled, (state, action) => {
                state.loading = false;
                state.NDASign = action.payload;
            })
            .addCase(fetchNDASignApi.rejected, (state, action) => {
                state.loading = false;
                state.error = action.payload;
            })
            .addCase(fetchAdminpayoutlist.pending, (state) => {
                state.loading = true;
                state.error = null;
            })
            .addCase(fetchAdminpayoutlist.fulfilled, (state, action) => {
                state.loading = false;
                state.Adminpayoutlist = action.payload;
            })
            .addCase(fetchAdminpayoutlist.rejected, (state, action) => {
                state.loading = false;
                state.error = action.payload;
            })
            .addCase(fetchwithdraRetryApi.pending, (state) => {
                state.loading = true;
                state.error = null;
            })
            .addCase(fetchwithdraRetryApi.fulfilled, (state, action) => {
                state.loading = false;
                state.withdrawreuestRetry = action.payload;
            })
            .addCase(fetchwithdraRetryApi.rejected, (state, action) => {
                state.loading = false;
                state.error = action.payload;
            })
            .addCase(fetchUserWalletTransactionHistory.pending, (state) => {
                state.loading = true;
                state.error = null;
            })
            .addCase(fetchUserWalletTransactionHistory.fulfilled, (state, action) => {
                state.loading = false;
                state.userWalletTransactionHistory = action.payload;
            })
            .addCase(fetchUserWalletTransactionHistory.rejected, (state, action) => {
                state.loading = false;
                state.error = action.payload;
            })
            // fetchgetonboardinglink
        // fetchwithdraRequests

    },
});

const dminwithdrarequestSliceReducer = AdminwithdrarequestSlice.reducer;

export const { clearWithdrawRequest } = AdminwithdrarequestSlice.actions;

export default dminwithdrarequestSliceReducer;


